// extracted by mini-css-extract-plugin
module.exports = {"fixedWidget":"fixedWidget___wE_MT"};